module.exports = __webpack_public_path__ + "static/slack-logo-878d93dedd330db39784fa85619df6b3.svg";